import React from 'react'
import { VictoryPie } from 'victory'
import colors from '@fe/ui/colors'

const Speedometer = (props) => {
  const { width, total = 100, label, fatLabelText = 18, style } = props
  const radius = width / 2
  const innerRadius = radius * 0.8
  const bigNumberSize = 28
  const smallTextSize = 14

  const isValid = total > 0
  //  show red (#d54336) if below 25%, orange (#f69500) if below 50% and green (#739d3b) for better
  const value = isValid
    ? props.value || 0
    : 0

  const percentage = isValid
    ? value / total * 100
    : 0

  const percentageLabel = isValid
    ? `${Math.round(percentage)}%`
    : 'N/A'

  const valueLabel = isValid
    ? `${value}/${total}`
    : 'N/A'

  const color = percentage < 25
    ? colors.lightRed
    : percentage < 50
      ? colors.lightOrange
      : colors.lightGreen

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', ...style }}>
      <svg width={width} height={width}>
        <VictoryPie
          standalone={false}
          startAngle={-120}
          endAngle={120}
          height={width}
          width={width}
          labelRadius={0.3 * width}
          padding={2}
          style={{
            labels: { fill: 'transparent' },
            data: { fill: (d) => d.fill }
          }}
          innerRadius={innerRadius}
          data={[
            { y: value, fill: color },
            { y: Math.max(total, 1) - value, fill: colors.paleBlue }
          ]}
        />
        <text
          fill={colors.primaryDarkGreen}
          fontSize={`${bigNumberSize}`}
          x={radius}
          y={(radius)}
          height={bigNumberSize}
          dy={0}
          textAnchor='middle'
        >
          {percentageLabel}
        </text>
        <text
          fill={colors.lightBlue}
          fontSize={`${smallTextSize}`}
          x={radius}
          y={radius + smallTextSize}
          height={smallTextSize}
          dy={5}
          textAnchor='middle'
        >
          {valueLabel}
        </text>
        <text
          fill={colors.lightBlue}
          fontSize={`${fatLabelText}`}
          x={radius}
          y={radius + smallTextSize + fatLabelText + 5}
          height={fatLabelText}
          dy={10}
          textAnchor='middle'
        >
          {`${label}`}
        </text>
      </svg>
    </div>

  )
}

export default Speedometer
